import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const PmTickets = ({
  fetchPmTicket,
  pmTicket,
  getPmTicketsFilterDropDown,
  pmTicketFilter,
}) => {
  const headers = [
    'Ticket ID',
    'Created On',
    'PM Schedule Month',
    'Site Number',
    'Assigned To',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setIsRoleId(roles);
      })();
    }, 1000);
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchPmTicket(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchPmTicket) {
        setIsLoading(true);
        await fetchPmTicket();
        await getPmTicketsFilterDropDown();
        setIsLoading(false);
      }
    })();
  }, [fetchPmTicket]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchPmTicket(filterData,val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Details', link: '/dashboard/tickets/view-details' },
      { name: 'Assign Ticket', link: '/dashboard/assign-ticket' },
    ];
    const actions = [
      { name: 'View Details', link: '/dashboard/tickets/view-details' },
    ];

    const tableData = [
      'ticket_id',
      'created_on',
      'pmScheduleMonth',
      'site_no',
      'assigned_to',
      'status',
    ];
    if (pmTicket && pmTicket.resultSets) {
      const data = pmTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: isRoleId === 9 ? actions : actions1,
          }
        )
      );
      if (data.length > 0) {
        setListData(data);
      }

      setPageCount(Math.ceil(pmTicket.total / pmTicket.per_page));
    }
  }, [pmTicket]);

  return (
    <Layout
      title={localization.pmTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={pmTicket?.from}
        onPageChange={onPageChange}
        detailList={pmTicket && pmTicket.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={0}
        isRoleId={isRoleId}
        listFilterData={pmTicketFilter?.sites ? pmTicketFilter : null}
        pmTicketFilter
      />
    </Layout>
  );
};

export default PmTickets;
